//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import React from 'react';
import styled, { css } from 'styled-components';

import { CenteredSpinner } from '@components/atoms/spinner/Spinner';
import { BodyText } from '@components/atoms/text/Text';

export const LoadingView = () => (
  <StyledStateContainer>
    <CenteredSpinner />
    <BodyText>Reading your file...</BodyText>
  </StyledStateContainer>
);

const StyledStateContainer = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacings[2]};
  `}
`;
